import { action, computed, observable, makeObservable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { EventIndexView } from '../../../../types/events';
import { EventApis } from '../../../../apis/events';
import { EventArchiveApis } from '../../../../apis/eventArchives';

const singleton = (() => {
  let instance: RemoteEventListState;
  return {
    getInstance() {
      if (!instance) {
        instance = new RemoteEventListState();
      }
      return instance;
    },
  };
})();
export class RemoteEventListState {
  events: RemoteResourceV3<EventIndexView[]> = RemoteResourceV3.loading();
  eventArchives: RemoteResourceV3<EventIndexView[]> = RemoteResourceV3.loading();
  initialized = false;

  constructor() {
    makeObservable(this, {
      events: observable,
      eventArchives: observable,
      init: action.bound,
      hasArchives: computed,
    });
  }

  async init() {
    if (this.initialized) return;
    this.initialized = true;
    await Promise.all([
      updateRemoteResourceV3(
        this.events,
        (v) => (this.events = v),
        () => EventApis.findAll()
      ),
      updateRemoteResourceV3(
        this.eventArchives,
        (v) => (this.eventArchives = v),
        () => EventArchiveApis.findAll()
      ),
    ]);
  }

  get hasArchives(): boolean {
    return this.eventArchives.getOrElse([]).length > 0;
  }

  static getInstance = singleton.getInstance;
}
